import React, { useState } from 'react';
import DateRangePicker from 'react-dates/lib/components/DateRangePicker';
import 'react-dates/initialize';
import ReactSVG from 'react-svg';
import moment from 'moment';
import customArrow from 'custom_datepicker_arrow.svg';
import DatepickerArrow from '../DatepickerArrow';
import checkIsCalendarDayBlocked from '../../utils/checkIsCalendarDayBlocked';
import ErrorBoundary from '../ErrorBoundary';

function PropertyAvailability({ property_bookings, rates }) {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const extraRates = [];

  return (
    <section id="availability" className="main-content-section">
      <h3 className="section-title">Availability</h3>
      {/* <p>Updated DATE • D Nights Minimum Stay</p> */}
      <div className="custom-calendar-wrapper read-only">
        <DateRangePicker
          startDate={null}
          startDateId="property_booking_start_date"
          endDate={null}
          endDateId="property_booking_end_date"
          onDatesChange={() => {}}
          focusedInput="startDate"
          onFocusChange={() => {}}
          numberOfMonths={1}
          noBorder
          readOnly
          navNext={<DatepickerArrow direction="next" />}
          navPrev={<DatepickerArrow direction="prev" />}
          customArrowIcon={<ReactSVG src={customArrow} />}
          onPrevMonthClick={month => setSelectedMonth(month.month())}
          onNextMonthClick={month => setSelectedMonth(month.month())}
          renderDayContents={day => {
            const betweenBookingDays = property_bookings.some(
              booking =>
                day.isBetween(
                  booking.table.start_date,
                  booking.table.end_date
                ) &&
                !day.isSame(booking.table.start_date, 'day') &&
                !day.isSame(booking.table.end_date, 'day')
            );

            const isPastDate = day.isBefore(moment(), 'd');

            const containsStartDate = property_bookings.some(booking =>
              day.isSame(booking.table.start_date, 'day')
            );
            const containsEndDate = property_bookings.some(booking =>
              day.isSame(booking.table.end_date, 'day')
            );

            const isHalfDayStart =
              containsStartDate && !containsEndDate && !isPastDate;
            const isHalfDayEnd =
              !containsStartDate && containsEndDate && !isPastDate;

            const dayIsBlocked =
              isPastDate ||
              (containsStartDate && containsEndDate) ||
              betweenBookingDays;

            const matchingRate = rates.find(
              rate =>
                day.isBetween(rate.table.start_date, rate.table.end_date) ||
                day.isSame(rate.table.start_date, 'd')
            );

            // Will be number from 0-6 of day of week
            if (day.day() === 6 && day.month() === selectedMonth) {
              if (matchingRate) {
                extraRates.push(
                  <div className="rates-container" key={day.valueOf()}>
                    {matchingRate.table.weekend_rate > 0 && (
                      <span>Wkd: ${matchingRate.table.weekend_rate}</span>
                    )}
                    {matchingRate.table.weekly_rate > 0 && (
                      <span>Week: ${matchingRate.table.weekly_rate}</span>
                    )}
                    {matchingRate.table.monthly_rate > 0 && (
                      <span>Monthly: ${matchingRate.table.monthly_rate}</span>
                    )}
                  </div>
                );
              } else {
                extraRates.push(<div className="rates-container" />);
              }
            }

            const hasMatchingRate =
              matchingRate && matchingRate.table.nightly_rate > 0;

            const showPrice = !dayIsBlocked && hasMatchingRate;

            return (
              <div
                className={`custom-day-content ${
                  !showPrice ? 'no-price' : ''
                } ${isHalfDayStart ? 'half-day-start' : ''} ${
                  isHalfDayEnd ? 'half-day-end' : ''
                }`}
              >
                <span className="day-date">{day.date()}</span>
                <span className="day-price">
                  {showPrice &&
                    `$${Math.ceil(matchingRate.table.nightly_rate)}`}
                </span>
              </div>
            );
          }}
          isDayBlocked={day =>
            checkIsCalendarDayBlocked({
              day,
              bookings: property_bookings,
            })
          }
        />
        <aside className="extra-rates">{extraRates}</aside>
      </div>
    </section>
  );
}

export default function PropertyAvailabilityWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <PropertyAvailability {...props} />
    </ErrorBoundary>
  );
}
